/*** IMPORTS FROM imports-loader ***/
var define = false;

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export function animateOnScroll() {
  // any element with animateOnLoad class
  // this way would then let you handle animation in css
  ScrollTrigger.batch(".animateOnLoad", {
    toggleClass: "inView",
    once: true,
    start: "top 80%",
    end: 99999
  });

  // const animatedItems = gsap.utils.toArray('.animateOnLoad');
  // animatedItems.forEach((animatedItem,i) => {
  //   ScrollTrigger.create({
  //     trigger: animatedItem,
  //     start: 'top 80%',
  //     toggleActions: 'play none none none',
  //     end: 99999,
  //     toggleClass: 'inView',
  //     once: true
  //     //markers: true
  //   });
  // });
}
